import { type FC, type ReactNode } from 'react';

import { BuyerIncentivesBannerCompactLazy } from 'dibs-buyer-incentives/exports/BuyerIncentivesBannerCompactLazy.ts';

import { getPurchaseProtectionLink } from '../../helpers/purchaseProtectionLink.tsx';

export const PdpSharedBuyerIncentivesCompact: FC<{
    wrapperClassName?: string;
}> = ({ wrapperClassName }) => {
    const getLink = (chunk: ReactNode): ReactNode =>
        getPurchaseProtectionLink(
            'EBI seller info details click',
            'purchase-protection-learn-more'
        )(chunk);

    return (
        <BuyerIncentivesBannerCompactLazy getLink={getLink} wrapperClassName={wrapperClassName} />
    );
};
